import { useState } from "react";
import Proptypes from "prop-types";
import Checkbox from "@shared/v2/Checkbox";
import PanelCollapse from "@shared/v1/Panel/PanelCollapse";
import { DncFlag } from "@shared/Sms";

const LeadMatch = ({ match }) => {
  const [open, setOpen] = useState(false);
  const fullName = `${match.data.firstName} ${match.data.lastName}`.trim();

  return (
    <div>
      <div className="tw-flex tw-items-center tw-gap-[8px] tw-p-[8px]">
        <Checkbox onChange={() => setOpen(!open)} checked={open} label={fullName || "No Name"} />
      </div>
      <PanelCollapse collapsed={!open} className="tw-flex tw-gap-[16px] tw-px-[16px]">
        <input type="hidden" name="firstName" value={match.data.firstName} />
        <input type="hidden" name="lastName" value={match.data.lastName} />
        <div className="tw-basis-1/2 tw-flex tw-flex-col tw-gap-[8px]">
          {match.data.cellPhones?.map((phone) => (
            <Checkbox
              name="phoneDetailsAttributes"
              value={phone.phoneNumber}
              label={
                <div className="tw-flex tw-gap-[8px]">
                  {phone.phoneNumber} <DncFlag show={phone.doNotCall === "Y"} />
                </div>
              }
              key={phone.phoneNumber}
            />
          ))}
          {match.data.phoneNumbers?.map((phone) => (
            <Checkbox
              name="phoneDetailsAttributes"
              value={phone.phoneNumber}
              label={
                <div className="tw-flex tw-gap-[8px]">
                  {phone.phoneNumber} <DncFlag show={phone.doNotCall === "Y"} />
                </div>
              }
              key={phone.phoneNumber}
            />
          ))}
        </div>
        <div className="tw-basis-1/2 tw-flex tw-flex-col tw-gap-[8px]">
          {match.data.emailAddresses?.map((email) => (
            <Checkbox name="emailDetailsAttributes" value={email} label={email} key={email} />
          ))}
        </div>
      </PanelCollapse>
    </div>
  );
};

LeadMatch.propTypes = {
  match: Proptypes.shape({
    data: Proptypes.shape({
      firstName: Proptypes.string,
      lastName: Proptypes.string,
      cellPhones: Proptypes.arrayOf(
        Proptypes.shape({
          phoneNumber: Proptypes.string.isRequired,
          doNotCall: Proptypes.string,
        }),
      ),
      phoneNumbers: Proptypes.arrayOf(
        Proptypes.shape({
          phoneNumber: Proptypes.string.isRequired,
          doNotCall: Proptypes.string,
        }),
      ),
      emailAddresses: Proptypes.arrayOf(Proptypes.string),
    }),
  }).isRequired,
};

export default LeadMatch;
